import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalMadlibService, IGlobalMadlib } from './../../../shared/services/global-madlib/global-madlib.service';
import { UrlNavigationService } from './../../../shared/services/url-navigation/url-navigation.service';
import { SubLocationFilterSyncService } from './../../../shared/services/op-global-filter/sub-location-filter-sync.service';
import { ENTITY_TYPE } from '../../../shared/typings/types/entity-type.types';

@Injectable()
export class GlobalMadlibResolver implements Resolve<IGlobalMadlib> {
  private globalMadlibService = inject(GlobalMadlibService);
  private subLocationFilterSync = inject(SubLocationFilterSyncService);
  constructor () {}
  resolve (route: ActivatedRouteSnapshot): Observable<IGlobalMadlib> {
    // The sub-location uber filter must reflect the URL before any data resolver
    // fires — a shared link can carry a subLocationId — so it starts here, ahead
    // of the data loads, and self-syncs on later navigations.
    this.subLocationFilterSync.start();

    const entityType = UrlNavigationService.getEntityType(route) as ENTITY_TYPE;
    const entityId = UrlNavigationService.getEntityId(route);
    const { globalMadlibState } = route.queryParams;
    return this.globalMadlibService.initializeState({ entityType, entityId }, globalMadlibState);
  }
}
